import { render, staticRenderFns } from "./privateLetter.vue?vue&type=template&id=2dac0b16&"
import script from "./privateLetter.vue?vue&type=script&lang=js&"
export * from "./privateLetter.vue?vue&type=script&lang=js&"
import style0 from "./privateLetter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports